import React from 'react'
import PropTypes from 'prop-types'
import { useSpring, animated, config } from 'react-spring'

const openTransformConfig = {
  bottom: 'translate(2, 31) rotate(0)',
  center: 'translate(2, 19) rotate(0)',
  top: 'translate(2, 7) rotate(0)',
}

const closedTransformConfig = {
  bottom: 'translate(7, 35) rotate(-45)',
  center: 'translate(8, 7) rotate(45)',
  top: 'translate(7, 35) rotate(-45)',
}

const MenuIcon = ({ title, desc, width, height, isOpen }) => {
  const { top, center, bottom } = useSpring({
    config: config.stiff,
    to: isOpen ? closedTransformConfig : openTransformConfig,
  })
  return (
    <svg
      aria-labelledby="menu-icon-title menu-icon-desc"
      fill="#cccccc"
      height={height}
      viewBox="0 0 44 44"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title id="menu-icon-title">{title}</title>}
      {desc && <desc id="menu-icon-desc">{desc}</desc>}
      <animated.rect width="40" height="2" transform={top} />
      <animated.rect width="40" height="2" transform={center} />
      <animated.rect width="40" height="2" transform={bottom} />
    </svg>
  )
}

MenuIcon.propTypes = {
  desc: PropTypes.string,
  height: PropTypes.number,
  title: PropTypes.string,
  width: PropTypes.number,
}

MenuIcon.defaultProps = {
  desc: '',
  height: 0,
  title: '',
  width: 0,
}

export default MenuIcon
